var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSoundOn = function SvgSoundOn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32.704,
    height: 31.536,
    viewBox: "0 0 32.704 31.536",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 6.88)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.704,
    height: 31.536,
    rx: 4,
    transform: "translate(-7 -6.88)",
    fill: "#eb00ff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.263,5.2H0v7.313H3.263l6.581,5.4V-.2Z",
    transform: "translate(0 0.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.828 0.869)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.387,19.6l-.759-.816a9.858,9.858,0,0,0,3.178-7.2A9.676,9.676,0,0,0,48.6,4.416l.759-.816a10.738,10.738,0,0,1,3.572,7.987A10.919,10.919,0,0,1,49.387,19.6Z",
    transform: "translate(-48.6 -3.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.434 2.531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.388,23.541l-.759-.816a6.444,6.444,0,0,0,2.053-4.669A6.261,6.261,0,0,0,43.6,13.416l.759-.816a7.323,7.323,0,0,1,2.447,5.456A7.5,7.5,0,0,1,44.388,23.541Z",
    transform: "translate(-43.6 -12.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.316,27.45l-.816-.787a3.129,3.129,0,0,0,0-4.275l.816-.787A4.267,4.267,0,0,1,39.316,27.45Z",
    transform: "translate(-38.5 -21.6)",
    fill: "#fff"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSoundOn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sound-on.7135c85e.svg";
export { ForwardRef as ReactComponent };